{
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }
    if(window.eHanlin.platform_env === undefined || window.eHanlin.platform_env === null){
        window.eHanlin.platform_env = {}
        window.eHanlin.platform_env.cdn = 'https://ehanlin-web-public-resource.s3-ap-northeast-1.amazonaws.com'
    }
    const template = `
        <style>
            .floatbtn{
                display:-webkit-box;
                display:-ms-flexbox;
                display:flex;
                position:fixed;
                -webkit-box-align:center;
                -ms-flex-align:center;
                align-items:center;
                -webkit-box-orient:vertical;
                -webkit-box-direction:normal;
                -ms-flex-direction:column;
                flex-direction:column;
                -webkit-box-sizing:border-box;
                box-sizing:border-box;
                z-index:99900;
                right:21px;
                bottom:21px;
                -moz-user-select:none;
                -webkit-user-select:none;
                -ms-user-select:none;
                user-select:none;
            }
            a{
                display:-webkit-box;
                display:-ms-flexbox;
                display:flex;
                -webkit-box-sizing:border-box;
                box-sizing:border-box;
                cursor:pointer;
                margin-bottom:12px
            }

            .totop{
                opacity:0;
                display:-webkit-box;
                display:-ms-flexbox;
                display:flex;
                -webkit-box-sizing:border-box;
                box-sizing:border-box;
                cursor:pointer;
                margin-bottom:12px;
                -webkit-transition:opacity .3s;
                transition:opacity .3s;
            }
            @media (max-width:991px){
                .floatbtn a{
                    display:none
                }
                .totop{
                    display:none
                }
            }
        </style>
        
        <div class="floatbtn">
            <div class="totop">
                <img src="${window.eHanlin.platform_env.cdn}/web/eh-floatbtn/totop.svg" alt="至頂部">
            </div>
            <a id="e-coach-btn">
                <img src="${window.eHanlin.platform_env.cdn}/web/eh-floatbtn/ecoach.svg" alt="e家教">
            </a>
            <a href="/event/line/" target="_blank">
                <img src="${window.eHanlin.platform_env.cdn}/web/eh-floatbtn/cs2020.svg" alt="客服">
            </a>
        </div>
    `;
    customElements.define('eh-floatbtn', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'});
            shadowRoot.innerHTML = template;

            let topBtn = shadowRoot.querySelector('.totop');
            let eventName = "toTop";
            let scrollTop = new CustomEvent(eventName);
            document.addEventListener(eventName,function(){
                document.body.scrollIntoView({behavior: 'smooth', block: 'start'});
                document.documentElement.scrollIntoView({behavior: 'smooth', block: 'start'});
            });
            topBtn.onclick = function(){
                document.dispatchEvent(scrollTop);
            }

            shadowRoot.querySelector("#e-coach-btn").addEventListener('click', (event) => {
                let cookieToken = getEhToken();
                if(cookieToken!=null){
                    let user = cookieToken.user;
                    if(!!user){
                        fetch(`/coach-web/eTutorStudent/isStudent?id=${user.userId}`)
                            .then(response => {
                                if (response.ok) {
                                    return response.text();
                                }
                            })
                            .then(result => {
                                if (result=="true") {
                                    window.location.href = "/app/coach/";
                                }else{
                                    window.location.href = "/event/ecoach/intro-jr.html"
                                }
                            })
                    }else{
                        window.location.href = "/event/ecoach/intro-jr.html"
                    }
                }
            });

            function addEvent(obj,type,fn){
                if(obj.attachEvent){
                    obj.attachEvent('on'+type,function(){
                        fn.call(obj);
                    })
                }
                else{
                    obj.addEventListener(type,fn,false);
                }
            }

            addEvent(window,'scroll',function(){
                if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    shadowRoot.querySelector('.totop').style.opacity = "1";
                } else {
                    shadowRoot.querySelector('.totop').style.opacity = "0"
                }
            });
        }
    });
}
